<template>
  <svg
    class="tei-connectors"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="`0 0 ${width} ${height}`"
  >
    <g
      class="tei-connectors__lines"
      stroke-width="5"
    >
      <line
        v-for="line in connectorLines"
        :key="`${line.fromPoint.x}${line.fromPoint.y}${line.toPoint.x}${line.toPoint.y}`"
        :x1="line.fromPoint.x"
        :y1="line.fromPoint.y"
        :x2="line.toPoint.x"
        :y2="line.toPoint.y"
        :class="{ 'tei-connectors__connector--animated': line.animated }"
        :style="line.animated ? {
          strokeDashoffset: getConnectorLength(line),
          strokeDasharray: getConnectorLength(line),
        } : undefined"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 0,
    },
    height: {
      type: Number,
      default: 0,
    },
    connectorLines: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getConnectorLength(line) {
      return Math.sqrt(((line.fromPoint.x - line.toPoint.x) ** 2)
        + ((line.fromPoint.y - line.toPoint.y) ** 2));
    },
  },
};
</script>

<style lang="stylus">
.tei-connectors {
  /*
    To animate the connector lines drawn in the SVG:
    1. We make the line dashed and make the dash length the length of the entire line.
    2. Then we offset the dash the opposite direction of the animation at a distance
      equal to the length of the line.
    3. Then we animate the offset dash back to an offset of 0 to create the animation effect.
  */
  @keyframes connector {
    to {
      stroke-dashoffset: 0;
    }
  }

  &__connector {
    &--animated {
      animation: connector .25s ease-out forwards;
    }
  }

  &__lines {
    stroke: var(--tei-connector-color);
  }
}
</style>
